/* Handora: change a cart line's variant (size, shape, length) from the cart page and the cart drawer.
   snippets/cart-line-items.liquid prints a [data-ho-vedit] "Change size" cell in each line's bottom bar,
   with the product's variants. This file puts a transparent menu over that cell listing every variant
   (e.g. "M / Almond / Short"). Picking one swaps the line: the new variant is added first with the same
   quantity and properties, then the old line is removed, so a dropped connection can leave an extra set
   in the cart but never loses one. Then the theme redraws the cart (no page reload). Styles: assets/ho-cart-2c.css.
   It also writes the milestone labels ("3 sets · 1 free") under the free-set progress bar. */
(function () {
  if (window.__hoVariantEdit) return;
  window.__hoVariantEdit = true;

  function parse(text, fallback) { try { var v = JSON.parse(text); return v == null ? fallback : v; } catch (e) { return fallback; } }

  function setup(box) {
    if (box.__hoVedit) return;
    box.__hoVedit = true;
    var data = box.querySelector('script');
    var variants = parse(data ? data.textContent : '[]', []);
    var names = parse(box.getAttribute('data-options'), []);
    var cur = String(box.getAttribute('data-variant'));
    var current = null;
    for (var i = 0; i < variants.length; i++) if (String(variants[i][0]) === cur) current = variants[i];
    if (!current || !names.length) return;
    box.__variants = variants;
    var title = box.getAttribute('data-title') || '';
    var label = box.querySelector('.ho-vedit__label');
    if (!label) { label = document.createElement('span'); label.className = 'ho-vedit__label'; label.textContent = 'Change size'; box.insertBefore(label, box.firstChild); }
    label.setAttribute('data-text', label.textContent);
    var sel = document.createElement('select');
    sel.className = 'ho-vedit__select';
    sel.setAttribute('data-ho-vedit-opt', '');
    sel.setAttribute('aria-label', 'Change ' + names.join(' / ').toLowerCase() + ' - ' + title);
    variants.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v[0];
      o.textContent = v[1].join(' / ') + (v[2] ? '' : ' (sold out)');
      if (!v[2] && v !== current) o.disabled = true;
      if (v === current) o.selected = true;
      sel.appendChild(o);
    });
    sel.setAttribute('data-current', current[0]);
    box.appendChild(sel);
    var item = box.closest('[data-cart-item]');
    if (item) item.classList.add('ho-vedit-on');
  }

  /* Message line at the bottom of the line's card (sold out, errors). */
  function msgEl(box) {
    var card = box.closest('[data-cart-item]') || box;
    var m = card.querySelector(':scope > .ho-vedit__msg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'ho-vedit__msg';
      m.setAttribute('role', 'status');
      m.hidden = true;
      card.appendChild(m);
    }
    return m;
  }

  function scan(scope) { (scope || document).querySelectorAll('[data-ho-vedit]').forEach(setup); }

  function say(box, text, info) {
    var label = box.querySelector('.ho-vedit__label');
    if (info) { if (label) label.textContent = text; return; }
    if (label) label.textContent = label.getAttribute('data-text') || 'Change size';
    var m = msgEl(box);
    m.textContent = text || '';
    m.hidden = !text;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Could not update the cart.'); e.status = r.status; throw e; }
        return j;
      });
    });
  }

  /* Ask the theme to redraw the drawer / cart page from the server's cart, then clear the
     "Updating" state on anything still on screen. Reload only when the theme cannot redraw. */
  function idle() {
    document.querySelectorAll('[data-ho-vedit].is-busy').forEach(function (b) {
      b.classList.remove('is-busy');
      b.querySelectorAll('select').forEach(function (s) { s.disabled = false; });
      var l = b.querySelector('.ho-vedit__label');
      if (l) l.textContent = l.getAttribute('data-text') || 'Change size';
    });
  }
  function redraw() {
    var c = window.cart, p = null;
    if (!c || typeof c.getCart !== 'function') { location.reload(); return; }
    try { p = c.getCart(); } catch (e) {}
    if (p && typeof p.then === 'function') p.then(idle, idle);
    setTimeout(idle, 4000);
  }

  var busy = false;
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-ho-vedit-opt]');
    if (!sel) return;
    /* Keep the theme's cart form from treating this as a quantity change. */
    e.stopPropagation();
    var box = sel.closest('[data-ho-vedit]');
    if (!box || !box.__variants) return;
    var sels = [sel];
    function revert() { sel.value = sel.getAttribute('data-current'); }
    var match = null;
    box.__variants.forEach(function (v) { if (String(v[0]) === sel.value) match = v; });
    if (!match) { revert(); say(box, 'That option is not available.'); return; }
    if (!match[2]) { revert(); say(box, match[1].join(' / ') + ' is sold out.'); return; }
    var oldId = parseInt(box.getAttribute('data-variant'), 10);
    if (match[0] === oldId) { say(box, ''); return; }
    if (busy) { revert(); return; }
    busy = true;
    box.classList.add('is-busy');
    sels.forEach(function (s) { s.disabled = true; });
    say(box, 'Updating…', true);

    var key = box.getAttribute('data-key');
    var qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
    var props = parse(box.getAttribute('data-props'), {});
    var plan = box.getAttribute('data-plan');
    function line(id) {
      var it = { id: id, quantity: qty };
      if (props && typeof props === 'object' && Object.keys(props).length) it.properties = props;
      if (plan) it.selling_plan = parseInt(plan, 10);
      return it;
    }

    /* Lines of the old variant with the same properties. Line keys change when the free set
       discount re-splits the cart after the add, so the old line is found again by variant. */
    function sig(p) {
      if (!p || typeof p !== 'object' || Array.isArray(p) || !Object.keys(p).length) return '{}';
      return JSON.stringify(Object.keys(p).sort().map(function (k) { return [k, p[k]]; }));
    }
    var propsSig = sig(props);
    function oldLines(cart) {
      return (cart.items || []).filter(function (it) {
        return it.variant_id === oldId && sig(it.properties) === propsSig;
      });
    }
    function getCartJson() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function removeOld(target) {
      return getCartJson().then(function (cart) {
        var lines = oldLines(cart), have = 0, updates = {};
        lines.forEach(function (it) { have += it.quantity; });
        var cut = have - target;
        if (cut <= 0) return null;
        for (var i = lines.length - 1; i >= 0 && cut > 0; i--) {
          var take = Math.min(cut, lines[i].quantity);
          updates[lines[i].key] = lines[i].quantity - take;
          cut -= take;
        }
        return post('/cart/update.js', { updates: updates });
      });
    }

    var before = 0;
    getCartJson()
      .then(function (cart) {
        oldLines(cart).forEach(function (it) { before += it.quantity; });
        return post('/cart/add.js', { items: [line(match[0])] });
      })
      .then(function () {
        var target = Math.max(0, before - qty);
        return removeOld(target).catch(function () {
          return removeOld(target).catch(function () {
            var e = new Error('The new size was added, but the old one is still in your cart. Please remove it.'); e.status = 422; throw e;
          });
        });
      })
      .then(function () {
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ho_cart_variant_change', { from: oldId, to: match[0] }); } catch (x) {}
        busy = false;
        redraw();
      })
      .catch(function (err) {
        busy = false;
        box.classList.remove('is-busy');
        sels.forEach(function (s) { s.disabled = false; });
        revert();
        say(box, (err && err.status === 422 && err.message) ? err.message : 'Could not change this item. Please try again.');
        redraw();
      });
  }, true);

  /* Free-set progress bar (ho-tier engine): label each dot with its offer,
     e.g. "3 sets · 1 free". The dots sit at (sets / largest offer) of the track. */
  var tierTimer = 0;
  function tierSoon() { clearTimeout(tierTimer); tierTimer = setTimeout(tierLabels, 60); }
  function tierLabels() {
    var cfg = window.HO_TIER;
    var offers = cfg && cfg.offers;
    if (!offers || !offers.length) return;
    var max = 0;
    offers.forEach(function (o) { max = Math.max(max, o.buy + o.get); });
    document.querySelectorAll('.ho-tier').forEach(function (tier) {
      var bar = tier.querySelector('.ho-tier__bar');
      if (!bar) return;
      var box = tier.querySelector('.ho-tier__labels');
      if (box) return; /* hx-ho-tier-engine-1.js keeps the labels current (v5) */
      var html = '';
      offers.forEach(function (o) {
        var need = o.buy + o.get;
        html += '<span' + (need >= max ? ' class="is-end"' : '') + ' style="left:' + (need / max * 100) + '%"><b>' + need + ' sets</b><small>' + o.get + ' free</small></span>';
      });
      box = document.createElement('div'); box.className = 'ho-tier__labels'; box.setAttribute('aria-hidden', 'true'); bar.parentNode.insertBefore(box, bar.nextSibling);
      box.innerHTML = html;
    });
  }

  function start() {
    scan();
    tierLabels();
    document.addEventListener('ho:cart', function () { setTimeout(tierLabels, 150); });
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var n = records[i].addedNodes;
          for (var j = 0; j < n.length; j++) {
            if (n[j].nodeType !== 1) continue;
            if (n[j].matches && n[j].matches('[data-ho-vedit]')) setup(n[j]);
            else if (n[j].querySelector && n[j].querySelector('[data-ho-vedit]')) scan(n[j]);
            if (n[j].classList && (n[j].classList.contains('ho-tier__node') || n[j].classList.contains('ho-tier') || (n[j].querySelector && n[j].querySelector('.ho-tier__node')))) tierSoon();
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();